import React from "react";
import { connect } from 'react-redux'

import { setupActions } from '../actions';

import { Card, Col, CardBody, Table  } from "reactstrap";
    
import { Spinner } from 'components/Icons/Spinner';
import Switch from "react-switch";

var sdf = require('date-format');
var authLib =  require ('modules/auth/authLib');

class ParametersCrud extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
          modalOpen: false,
          fullParams: false
        };
      }

    
    componentDidMount() {
        this.setState({ fullParams: authLib.authOK (this.props.userRoles, "FULL_PARAMS") });

    }

 
switchParam = ( row ) => {
    this.props.updateParameter ( this.props.token,  row.param_id, {  param_value: (row.param_value==='Y'?'N':'Y') }, this.props.userID) ;

};

render() {

    return (
        <>
         <Col> 
            <Card >
                <CardBody>
                         <h5>{this.props.title}</h5>
                                   
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    {this.state.fullParams && <th>Grupo</th>}
                                    <th>Descripción</th>
                                    <th>Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.collection && this.props.collection.map( (row) => {
                                    return (

                                        ((this.state.fullParams) || (row.group_id === 'STD') ?
                                            <tr key={row.param_id}>
                                                <td className="text-left">{row.param_id}</td>
                                                { this.state.fullParams && <td className="text-left">{row.group_id}</td> }
                                                <td className="text-left">{row.description}<br />
                                               
                                               <span className="blockquote-footer" 
                                                    style={{color: row.justUpdated?"red":""}}>Última modificación: <b>{row.login_id} </b>
                                                    {row.justUpdated?
                                                        "recién"
                                                        :
                                                        "el "+ sdf.asString('dd/MM/yyyy hh:mm:ss', new Date(row.last_update)) 
                                                    } </span>
                                                
                                                </td>
                                                <td className="text-left">
                                                { row.param_options==='YESNO'? 
                                                    this.props.view.loadingModules["updating_"+row.param_id]?
                                                        <Spinner />
                                                        :                             
                                                        <Switch
                                                            onChange={() => {this.switchParam(row) }}
                                                            checked={row.param_value==="Y"}
                                                            className="react-switch"
                                                            disabled={row.group_id!=='STD'}
                                                            
                                                            />


                                                        :
                                                        row.param_value
                                                    }
                                                

        


                                                </td>
                                            </tr>
                                            :
                                            null
                                        )
                                    );
                                }) }
                            </tbody>
                        </Table> 
                </CardBody>
            </Card>
        </Col>
        </>
    )
    }
}


const mapStateToProps = state => {
    return {
        userRoles: state.auth.session.userRoles,
        view: state.view,
        userID: state.auth.session.user.login_id,
        school: state.config.school,
        token: state.auth.session.jwt_token,
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 

        updateParameter: ( token,  param_id, data, userID ) => {
            dispatch( setupActions.updateParameter( token,  param_id, data, userID )) ;
        }
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(ParametersCrud);

